import React from 'react';
import { ThemeProvider } from '@material-ui/core';
import theme from '../lib/theme';
import darkTheme from '../lib/theme/darkTheme'
import { getQueryParam} from '../lib/utils/utility';
import HomeConnectServices from '../lib/layouts/HomeConnectServices'; 
class App extends React.Component {
  render() {
    const params = getQueryParam(null, true)
    const isDarkMode = params.isDarkMode || this.props.isDarkMode
    const themePalets = isDarkMode ? darkTheme : theme
    
    return (
      <ThemeProvider theme={themePalets}>
        <div className={isDarkMode ? 'dark-theme':'light-theme'}>
        <HomeConnectServices  {...this.props} />
        </div>
      </ThemeProvider>
    );
  }
}
 
export default App